<template>
  <v-container>
    <btn-a class="ma-2" outlined rounded color="primary" @click="$emit('new')">
      <v-icon>mdi-plus</v-icon>
    </btn-a>
    <v-list two-line subheader v-if="value && value.length > 0">
      <div v-for="(item,i) in value" :key="i">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title v-text="textList != null ? item : item[itemTitle]"></v-list-item-title>
            <v-list-item-subtitle v-if="textList != null" v-text="item[itemSubtitle]"></v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon @click="$emit('edit',{item:item,index:i})">
              <v-icon color="warning">mdi-pencil</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-action>
            <v-btn icon @click="$emit('remove',{item:item,index:i})">
              <v-icon color="error">mdi-delete</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-divider v-if="value && value.length > 0"></v-divider>
      </div>
    </v-list>
    <!-- <dialog-d
      ref="dialogRef"
      title="title"
      @confirm="confirm(false,formValidation ? formValidation.validate() : true)"
      @cancel="cancel"
    >
      <slot name="dialog-form" :item="itemSelected"></slot>
    </dialog-d> -->
  </v-container>
</template>


<script>
//import objectValueListMixin from "@/mixins/objectPageLists/objectValueListMixing";
export default {
 // mixins: [objectValueListMixin],
  props: {
    title: {},
    textList: {},
    itemTitle: {},
    itemSubtitle: {},
    formValidation: {},
    formModelDefault: {
      default: () => {
        return {};
      }
    },
    value: {
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {};
  },

  methods: {}
};
</script>